import {
  extractSettingAs,
  formatDisplayPoints,
  round,
  shouldHideGradeUntilDueDate,
} from '@macmillan-learning/gradebook-shared';
import _ from 'lodash';
import React from 'react';

export const renderOutOfPointsLabel = (
  points,
  showOutOf,
  showPointsDecimals = false,
) => {
  if (!showOutOf) return null;
  const safePoints = getPointsSafely(points, showPointsDecimals);

  return <small>Out of {safePoints}</small>;
};

export const titleHelper = (assignment, settings) => {
  if (_.isEmpty(assignment)) return '';

  if (assignment.isDropped) {
    return 'Dropped Lowest';
  }

  const gradesToReportVal = extractSettingAs(settings, 'gradesToReport', (x) =>
    _.toInteger(x.value),
  );
  if (
    shouldHideGradeUntilDueDate({
      gradesToReport: gradesToReportVal,
      pastDue: assignment.past_due,
      isInstructorEntered: assignment.isInstructorEntered,
    })
  ) {
    return 'In Progress';
  }

  return '';
};

export const getDisplayPoints = ({
  assignment,
  settings,
  isAssigned,
  points,
  outOfTotal,
  isgCurrentView,
}) => {
  const formattedPoints = assignment
    ? formatDisplayPoints(assignment, settings, isAssigned)
    : formatDisplayPoints({ studentPoints: points }, settings, isAssigned);

  const outOf =
    !!isgCurrentView && outOfTotal && Number(formattedPoints)
      ? getPointsSafely(outOfTotal, true)
      : null;

  const outOfString = outOf ? `/${round(outOf, 2, true)}` : '';

  return `${formattedPoints}${outOfString}`;
};

const getPointsSafely = (pts, showPointsDecimals = false) => {
  if (_.isNaN(pts)) return 0;
  return round(parseFloat(pts), showPointsDecimals ? 2 : 0);
};
